import { C as CosmosCheckbox$1, d as defineCustomElement$1 } from './p-DJyNTNX7.js';

const CosmosCheckbox = CosmosCheckbox$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosCheckbox, defineCustomElement };
